import script from "./sign-up-page.vue?vue&type=script&setup=true&lang=ts"
export * from "./sign-up-page.vue?vue&type=script&setup=true&lang=ts"

import "./sign-up-page.vue?vue&type=style&index=0&id=9dfb0740&lang=less"

const __exports__ = script;

export default __exports__